import axios from 'axios'
import config from '../config'

export function siteChecker(body) {
  return axios.post(`${config.API_URL}/iapi/site-checker`, body)
}
